import { coreTagsUnlinkPostAsyncSlice } from './post';

export const { requestPostCoreTagsUnlink, resetPostCoreTagsUnlink } = coreTagsUnlinkPostAsyncSlice.asyncActionCreators;
